<script setup lang="ts">
const props = defineProps<{
  size?: 'sm' | 'md' | 'lg' | 'xl'
  variant?: 'verified' | 'premium'
}>()

const badgeColor = computed(() => props.variant === 'premium' ? 'warning' : 'success')
const badgeIcon = computed(() => props.variant === 'premium' ? 'i-lucide-crown' : 'i-lucide-shield-check')
const badgeLabel = computed(() => props.variant === 'premium' ? 'Doporučujeme' : 'Ověřeno')
</script>

<template>
  <UBadge
    :color="badgeColor"
    variant="subtle"
    :size="size"
    :leading-icon="badgeIcon"
    :label="badgeLabel"
  />
</template>
